<template>
  <div class="page product-con">
    <ProductConSwiper :imgUrls="imgUrls"></ProductConSwiper>

    <div class="nav acea-row row-between-wrapper">
      <div class="money">
        ￥
        <div class="num" v-text="info.price"></div>
        <div class="state">销量：{{ info.sales + sales }}</div>
      </div>
      <div class="acea-row row-middle">
        <div class="times">
          <div>距活动结束仅剩</div>
          <CountDown
            :is-day="true"
            :datatime="info.stopTime"
            v-if="info.stopTime"
          ></CountDown>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
    </div>

    <div class="wrapperRush">
      <div class="introduce acea-row row-between">
        <div class="infor" v-text="info.title"></div>
        <!--        <div class="iconfont icon-fenxiang" @click="setPosterImageStatus"></div>-->
      </div>
      <!--      <div class="label acea-row row-middle">-->
      <!--        <div class="stock">库存:{{info.sales}}</div>-->
      <!--        <div v-text="'销量:' + info.sales ||112"></div>-->
      <!--      </div>-->
    </div>
    <div class="product-intro">
      <div class="title">产品介绍</div>
      <div class="conter" v-html="info.content"></div>
    </div>
    <div class="product-intro" v-if="info.remark">
      <div class="title">购买须知</div>
      <div class="notes" v-html="info.remark"></div>
    </div>

    <div style="height: 1.2rem"></div>
    <div class="cover">
      <!--      <div class="main-content" v-html="activity.content"></div>-->

      <div class="footer acea-row row-between-wrapper">
        <div class="item" @click="setShareInfoStatus">
          <div class="iconfont icon-fenxiang"></div>
          <div>分享</div>
        </div>
        <div class="item" @click="toKefu">
          <div class="iconfont icon-kefu"></div>
          <div>客服</div>
        </div>
        <div class="item" @click="toHome">
          <div class="iconfont icon-yonghu-xianxing"></div>
          <div>我的</div>
        </div>
        <div class="bnt acea-row">
          <div class="buy" @click="tapBuy" v-if="info.status == 1">
            立即购买
          </div>
          <div class="buy disabled" v-if="info.status == 0">
            别着急，商家在赶来的路上
          </div>
          <div class="buy disabled" v-if="info.status == 2">活动已下架</div>
        </div>
      </div>
    </div>

    <action-sheet v-model="show" cancel-text="取消" close-on-click-action>
      <van-notice-bar
        wrapable
        :scrollable="false"
        :text="`请输入正确的姓名和联系方式，方便为您同步创建会员信息；如果您已经是【${info.shopName}】门店的会员,还未绑定公众号，请在支付后联系门店绑定处理。`"
      />
      <div class="content">
        <field
          v-model="member.trueName"
          label="姓名"
          placeholder="请输入您的姓名"
          required
          error-message="请输入您的姓名"
        />
        <field
          v-model="member.phone"
          label="电话"
          placeholder="请输入您的电话号码"
          required
          error-message="请输入您的电话号码"
        />
        <field
          v-model="member.address"
          label="地址"
          placeholder="请输入您的地址"
          required
          error-message="请输入您的地址"
          v-if="info.postage == 1"
        />
        <van-button round block class="btn-buy" @click="doConfirm"
          >同意开通会员，并支付</van-button
        >
      </div>
    </action-sheet>
    <action-sheet v-model="kfshow" cancel-text="取消" close-on-click-action>
      <div class="content">
        <a :href="'tel:' + info.phone">{{ info.phone }}</a>
      </div>
    </action-sheet>

    <share-info
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></share-info>
  </div>
</template>
<script>
import { ActionSheet, Button as VanButton, Field, Toast } from "vant";
import ShareInfo from "@components/ShareInfo";
import { isWeixin } from "@utils";
import { getPurchaseView, createOrder, getIndentSales } from "@api/activity";
import { openShareAll, pay } from "@libs/wechat";
import { mapGetters } from "vuex";
import ProductConSwiper from "@components/ProductConSwiper.vue";
import CountDown from "@components/CountDown.vue";
import { getShopUser } from "@api/user";

export default {
  components: {
    CountDown,
    ProductConSwiper,
    ActionSheet,
    Field,
    VanButton,
    ShareInfo,
  },
  data: function () {
    return {
      sales: 0,
      toBuy: false,
      kfshow: false,
      show: false,
      shareInfoStatus: false,
      id: this.$route.params.id,
      account: {},
      info: {},
      imgUrls: [],
      member: {
        trueName: "",
        phone: "",
      },
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted: function () {
    this.getActive();
  },
  methods: {
    getShopUser() {
      getShopUser(this.info.shopId, this.userInfo.openid).then((resp) => {
        this.account = resp.result || {};
      });
    },
    getIndentSales() {
      getIndentSales(this.id).then((resp) => {
        this.$set(this, "sales", resp.result || 0);
      });
    },
    getActive() {
      getPurchaseView(this.id).then((resp) => {
        this.$set(this, "info", resp.result);
        if (this.info.remark) {
          this.info.remark = this.info.remark.replace(
            /(\n|\r|\r\n|↵)/g,
            "<br />"
          );
        }

        if (this.info.picture) {
          this.imgUrls = this.info.picture.split(",");
        }
        document.title = this.info.title;
        this.initShare();
        this.getShopUser();
        this.getIndentSales();
      });
    },
    toHome() {
      this.$router.push({ path: `/user` });
    },
    toSpread() {
      this.$router.push({ path: `/activity/poster/${this.id}` });
    },
    toKefu() {
      this.kfshow = true;
    },
    setShareInfoStatus: function () {
      this.shareInfoStatus = !this.shareInfoStatus;
    },
    tapBuy() {
      if (new Date().getTime() < this.info.startTime) {
        Toast("对不起，活动还没开始！！");
      } else if (new Date().getTime() > this.info.stopTime) {
        Toast("对不起，活动已经结束！！");
      } else if (!this.account.id) {
        this.show = true;
      } else {
        this.member.trueName = this.account.trueName;
        this.member.phone = this.account.phone;
        this.createOrder();
      }
    },
    doConfirm() {
      if (this.member.trueName === "" || this.member.phone === "") {
        return Toast("请填写联系人或联系人电话");
      }
      if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.member.phone)) {
        return Toast("请填写正确的手机号");
      }
      if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.member.trueName)) {
        return Toast("请填写您的真实姓名");
      }
      if (this.info.postage == 1 && !this.member.address) {
        return Toast("请填写您的邮寄地址");
      }
      this.createOrder();
    },
    createOrder() {
      Toast.loading({ message: "生成订单中", forbidClick: true });
      let order = {
        companyId: this.info.companyId,
        shopId: this.info.shopId,
        openId: this.userInfo.openid,
        nickname: this.userInfo.nickname,
        memberId: this.account.id,
        memberName: this.member.trueName,
        memberPhone: this.member.phone,
        memberAddress: this.member.address,
        memberIcon: this.userInfo.picture,
        comboId: this.info.comboId,
        comboName: this.info.comboName,
        title: this.info.title,
        price: this.info.price,
        totalAmount: this.info.price,
        payAmount: this.info.price,
        smsId: this.info.id,
        num: 1,
        smsType: 0,
        picture: "", //推广图
      };

      createOrder(order)
        .then((res) => {
          if (res.code === 200) {
            pay(res.result)
              .then(() => {
                this.show = false;
                if (this.account.id) {
                  Toast("恭喜你，支付成功！");
                  this.$router.replace({ path: "/user" });
                } else {
                  Toast("恭喜你，支付成功,请及时关注公众号，以便接收消费消息！");
                  this.$router.replace({ path: "/user/subscribe" });
                }
              })
              .catch(() => {
                // 用户取消或支付失败：不得提示成功，订单以服务端支付回调为准
                this.show = false;
                Toast("支付未完成，如已扣款请稍后在“我的订单”中查看");
              });
          } else {
            Toast.fail(res.message || "创建订单失败");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast.fail(err.msg || "创建订单失败");
        });
    },
    initShare: function () {
      if (isWeixin()) {
        let configAppMessage = {
          title: this.userInfo.nickname + " 邀请您参加 " + this.info.title,
          desc: this.info.comboName || this.info.title,
          link:
            location.origin + location.pathname + "?spread=" + this.userInfo.id,
          imgUrl: this.info.picture.split(",")[0],
        };
        console.info(configAppMessage);
        openShareAll(configAppMessage);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  .nav {
    padding: 0 0.125rem;
    height: 1.125rem;
    .money {
      display: flex;
      align-items: flex-end;
      .num {
        font-size: 0.628rem;
        margin-bottom: -0.125rem;
      }
      .state {
        font-size: 0.24rem;
        margin-left: 0.15rem;
      }
    }
  }

  .main-content {
    display: block;
    box-sizing: border-box;
    position: relative;
    padding: 0.25rem;
    line-height: 26px;

    ::v-deep img {
      display: block;
      max-width: 100% !important;
      height: auto;
      object-fit: contain;
    }
  }

  .footer {
    .btn {
      flex: 1;
      width: 80%;
    }
    .buy {
      border-radius: 0.5rem;
      width: 100%;
      &.disabled {
        background-image: none;
        background-color: #f4f4f5;
        color: #cccccc;
        border-color: #e9e9eb;
        cursor: not-allowed;
      }
    }
  }

  .btn-buy {
    background-image: linear-gradient(to right, #fa6514 0%, #e93323 100%);
    color: #fff;
    font-size: 0.28rem;
  }

  .content {
    padding: 20px 15px;
  }
}
</style>
